import React from 'react';
import DollarValueInflationComponent from "./DollarValueInflationComponent";
import {padCalendar} from "../../../util";

const formatDollarValueInflations = (dollarValueInflations) => {
    if (!dollarValueInflations) {
        return;
    }

    for(const dollarValueInflation of dollarValueInflations) {
        dollarValueInflation.date = padCalendar(dollarValueInflation.date);
    }

    return dollarValueInflations;
};

const DollarValueInflationContainer = (props) => {

    const data = formatDollarValueInflations(props.dollarValueInflations);
    return (
        <React.Fragment>
            <DollarValueInflationComponent dollarValueInflations={data} isDandO={sessionStorage.getItem('DANDO')}/>
        </React.Fragment>
    );

};

export default DollarValueInflationContainer;


// WEBPACK FOOTER //
// ./src/common/components/DollarValueInflation/DollarValueInflationContainer.js